import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/Branding/Logo';

function OnboardingSupplierScreen() {
  return (
    <div className="col-md-6 form-side">
      <div className="form-container text-center">
        <Logo /> {/* Using the imported Logo component */}
        <h1 className="text-success fw-bold mb-4">¡Bienvenido!</h1>
        <h4 className="mb-5">A la plataforma de proveedor Checkin</h4>
        <p>Te invitamos a responder nuestras preguntas,  que serán de utilidad para que seas parte de la comunidad de proveedores de Checkin.</p>
        <div className="buttons-container d-grid gap-3 mt-5 mb-5">
          {/* The 'to' prop should point to the correct route for supplier questions */}
          <Link to="/register" className="btn btn-checkin" role="button">Registrate</Link>
          {/* The 'to' prop should point to the supplier login route */}
          <Link to="/login" className="btn btn-outline-checkin" role="button">Iniciar sesión</Link>
        </div>
        {/* These links are placeholders as per index.html. Replace '#' with actual paths or handlers if needed. */}
        <p className="mt-3 text-muted small">protegido por reCAPTCHA · <a href="#">Privacidad</a> · <a href="#">Condiciones</a></p>
      </div>
    </div>
  );
}
export default OnboardingSupplierScreen;